<template>
  <div>
    <!-- 头部 -->
    <top></top>
    <div class="content_wrap container">
      <div class="content_title">
        <titleConfig
          :title="langSet == 'cn' ? '展商详情' : 'Exhibitor Details'"
          :type="2"
        ></titleConfig>
      </div>
      <div class="content-top flex flex_items_center flex_content_sb">
        <el-image
          v-if="details.logo"
          class="img-wrap"
          :src="details.logo"
          :fit="'contain'"
        ></el-image>
        <img class="img-wrap" v-else src="../../assets/kv.jpg" alt="" />
        <div class="content-text">
          <div class="title">
            {{ langSet == "cn" ? details.companyName : details.enCompanyName }}
          </div>
          <div class="content-label" v-if="langSet == 'cn'">
            <span
              v-for="(item, index) in details.productClass_name"
              :key="index"
              >{{ item }}</span
            >
          </div>
          <div class="content-label" v-else>
            <span
              v-for="(item, index) in details.productClass_name_en"
              :key="index"
              >{{ item }}</span
            >
          </div>
          <!-- <div>
            {{ langSet == "cn" ? "展位号" : "Booth No." }}：{{
              details.boothNo
            }}
          </div> -->
          <div>
            {{ langSet == "cn" ? "官网" : "Official Website" }}：{{
              details.officialWebsite
            }}
          </div>
        </div>
        <div class="btn-wrap">
          <div
            class="collect flex flex_items_center flex_content_center"
            :class="{ active: details.is_collect == 1 }"
            @click="toCollect"
          >
            <span v-if="details.is_collect == 0"
              >{{ langSet == "cn" ? "收藏" : "My Favorites" }} |</span
            >
            <span v-if="details.is_collect == 1"
              >{{ langSet == "cn" ? "已收藏" : "My Favorites" }} |</span
            >
            <img class="icon" src="../../assets/icon_h.png" />
          </div>
          <div class="collect bus-btn" @click="handleShowBusinessInquiry">
            {{ langSet == "cn" ? "商贸洽谈" : "Business Inquiry" }}
          </div>
        </div>
      </div>
      <div class="demand-wrap flex">
        <div class="left">
          <el-image
            v-if="details.qrcode_img"
            class="img"
            :src="details.qrcode_img"
            :fit="'cover'"
          ></el-image>
          <div>{{ langSet == "cn" ? "线上店铺" : "Online Store" }}</div>
        </div>
        <div class="right">
          <div class="title">
            {{ langSet == "cn" ? "商贸需求" : "Business demand" }}
          </div>
          <div
            class="swiper-container banner-swiper"
            v-if="busList.length > 0"
            ref="bannerDiv"
          >
            <div class="swiper-wrapper">
              <div
                class="swiper-slide"
                v-for="item in busList"
                :key="item.id"
                :data-id="item.id"
              >
                <div class="swiper-item">
                  <div class="title">
                    {{ langSet == "cn" ? "需求描述" : "Requirement" }}
                  </div>
                  <p>
                    {{
                      langSet == "cn" ? item.description : item.en_description
                    }}
                  </p>
                  <div class="swiper-btn" @click="response_show(item)">
                    {{ langSet == "cn" ? "应答" : "Response" }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <nodata v-if="busList.length == 0"></nodata>
        </div>
      </div>
      <div class="content-bottom">
        <div class="title">
          {{ langSet == "cn" ? "公司简介" : "Company Profile" }}
        </div>
        <div class="content-profile">{{ langSet == 'cn' ? details.introduction : details.synopsis }}</div>
        <div class="title">
          {{ langSet == "cn" ? "企业名片" : "Business card" }}
        </div>
        <p class="content-p">
          {{ langSet == "cn" ? "地址" : "Address" }}：{{
            langSet == "cn" ? details.address : details.enAddress
          }}
        </p>
        <p class="content-p">
          {{ langSet == "cn" ? "邮箱" : "Email" }}：{{ details.email }}
        </p>
        <p class="content-p">
          {{ langSet == "cn" ? "官网" : "Official Website" }}：{{
            details.officialWebsite
          }}
        </p>
      </div>
      <div class="content-subtitle flex flex_content_sb">
        <titleConfig
          :title="langSet == 'cn' ? '产品推荐' : 'Product Recommendations'"
          :type="2"
        ></titleConfig>
        <div
          class="btn-slide btn-slide-right small-btn flex_content_center flex_items_center"
          @click="toMore"
        >
          <div class="btn-main">
            {{ langSet == "cn" ? "查看更多" : "Details"
            }}<span class="icon"></span>
          </div>
        </div>
      </div>
      <productList :productLists="list"></productList>
    </div>
    <el-dialog title="" :visible.sync="dialogVisible" width="30%">
      <div class="dialog-wrap">
        <el-image
          v-if="details.qrcode_img"
          class="qrcode"
          :src="details.qrcode_img"
          :fit="'cover'"
        ></el-image>
        <p>扫码进行线上沟通</p>
      </div>
    </el-dialog>
    <!-- 底部 -->
    <bottom></bottom>
    <div class="dialog_box">
      <el-dialog
        v-if="response_dialogVisible"
        :title="langSet == 'cn' ? '应答' : 'Response'"
        :visible.sync="response_dialogVisible"
        width="30%"
        :before-close="handleClose"
      >
        <div>
          <div class="dialog_line"></div>
          <div class="dialog_box_top">
            <div class="dialog_title_picture">
              <img :src="userInfo.avatar" alt="" />
              <img
                v-if="userInfo.exhibitor_long_id"
                src="@/assets/authentication.png"
                alt=""
              />
            </div>
            <div style="color: #ffffff">
              <div class="dialog_title_name">
                <div>{{ userInfo.nickname }}</div>
                <div>{{ userInfo._duties }}</div>
                <div class="dialog_company">{{ userInfo.companyName }}</div>
              </div>
            </div>
            <!--          <img class="dialog_edit_img" src="@/assets/edit.png" alt=""/>-->
          </div>
          <div class="title_title">
            {{ langSet == "cn" ? "应答留言" : "Reply message" }}
          </div>
          <el-input
            type="textarea"
            :rows="7"
            resize="none"
            :placeholder="
              langSet == 'cn'
                ? '请详细描述您的需求'
                : 'Please provide a detailed description of your requirements'
            "
            v-model="request_content"
          >
          </el-input>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button
            class="dialog_submit"
            v-prevent-re-click
            type="primary"
            @click="submit"
            >{{ langSet == "cn" ? "提 交" : "Submit" }}</el-button
          >
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import top from "@/components/top.vue";
import bottom from "@/components/bottom.vue";
import titleConfig from "@/components/title.vue";
import nodata from "@/components/nodata.vue";
import { exhibitorDetail } from "@/api/company_api";
import { collect } from "@/api/api";
import productList from "../product/component/product_list.vue";
import { productLists } from "@/api/product_api";
import { business_publish_lists, business_reply_add } from "@/api/business_api";
import Swiper from "swiper"; // 注意引入的是Swiper
import router from "@/router";
import { sdkClick, sdkTime } from "../../sdk/useSdk";
import "../../../node_modules/swiper/css/swiper.min.css"; //
export default {
  // 配置title和meta数据
  metaInfo() {
    return {
      title: this.metaData.name_cn,
      meta: [
        {
          name: "description",
          content: this.metaData.description,
        },
        {
          name: "keywords",
          content: this.metaData.keywords,
        },
      ],
    };
  },
  components: {
    top,
    bottom,
    titleConfig,
    productList,
    nodata,
  },
  data() {
    return {
      userInfo: JSON.parse(localStorage.getItem("userInfo")),
      flag: localStorage.getItem("Flag") || "",
      response_dialogVisible: false,
      request_content: "",
      response_item: {},
      langSet: "",
      id: 0,
      type: 0,
      details: {},
      metaData: {},
      list: [],
      dialogVisible: false,
      swiper: null,
      busList: [],
      // 埋点
      timeKeeping: 0,
      interval: null,
    };
  },
  created() {},
  activated() {
    let menuArr = JSON.parse(localStorage.getItem("menuArr"));
    let path = this.$route.fullPath;
    this.metaData = this.findInNestedArray(
      menuArr,
      (item) => item.http_url_cn == path
    );
  },
  mounted() {
    this.langSet = this.$language;
    this.id = this.$route.query.id;
    //25.9.18 获取详情 dxm
    this.getDetails(this.id);
    let interval = setInterval(() => {
      this.timeKeeping = this.timeKeeping + 1;
    }, 1000);
    this.interval = interval;
    window.addEventListener("beforeunload", this.stopTimeKeeping);
  },
  beforeDestroy() {
    this.stopTimeKeeping();
    window.removeEventListener("beforeunload", this.stopTimeKeeping);
  },
  methods: {
    findInNestedArray(arr, condition) {
      // 使用map遍历外层数组
      const result = arr
        .map((item) => {
          if (condition(item)) return item;

          // 处理嵌套数组
          if (Array.isArray(item.children)) {
            const nestedResult = this.findInNestedArray(
              item.children,
              condition
            );
            if (nestedResult) return nestedResult;
          }
          return null;
        })
        .find((item) => item !== null);

      return result || null;
    },
    async getDetails(id) {
      let data = {
        exhibitor_long_id: id,
      };
      const res = await exhibitorDetail(data);
      this.details = res.data;
      console.log(this.details, '====details')
      if (this.details.id) {
        this.getBusList();
        this.getList();
      }
    },
    async getList() {
      let data = {
        companyid: this.details.id,
        page_size: 6,
      };
      const res = await productLists(data);
      this.list = res.data.lists;
    },
    async getBusList() {
      let data = {
        receive_companyid: this.details.id,
        status: 2,
      };
      const res = await business_publish_lists(data);
      this.busList = res.data.lists;
      setTimeout(() => {
        const mySwiper = new Swiper(".banner-swiper", {
          spaceBetween: 30,
          loop: true,
          slidesPerView: 2,
          autoplay: {
            delay: 3000,
            disableOnInteraction: false,
          },
          breakpoints: {
            320: {
              //当屏幕宽度大于等于320
              slidesPerView: 1,
              spaceBetween: 10,
            },
            768: {
              //当屏幕宽度大于等于768
              slidesPerView: 2,
              spaceBetween: 20,
            },
          },
        });
      }, 300);
    },
    async toCollect() {
      let data = {
        type: 2,
        dataId: this.details.id,
        status: this.details.is_collect == 0 ? 1 : 0,
      };
      if (data.status == 1) {
        sdkClick("收藏展商", this.details.companyName);
      }
      const res = await collect(data);
      if (res.code == 1) {
        this.$message.success(
          this.details.is_collect == 0 ? "收藏成功" : "取消收藏成功"
        );
        this.details.is_collect = this.details.is_collect == 0 ? 1 : 0;
      }
    },
    toMore() {
      this.$router.push({
        path: "/featuredProducts",
        query: {
          id: this.details.id,
        },
      });
    },
    response_show(item) {
      if (this.flag != "isLogin") {
        this.$message.warning("请先登录");
        setTimeout(function () {
          router.replace({
            path: "/login",
          });
        }, 1000);
        return false;
      }
      this.response_item = item;
      this.handleClose();
    },
    handleClose() {
      this.response_dialogVisible = !this.response_dialogVisible;
    },
    async submit() {
      if (this.request_content.length == 0)
        return this.$message.warning("请先填写应答留言");
      let data = {
        needid: this.response_item.id,
        reply: this.request_content,
      };
      const res = await business_reply_add(data);
      if (res.code == 1) {
        this.$message({
          message: res.msg,
          type: "success",
        });
        this.request_content = "";
        this.handleClose();
      } else {
        this.$message({
          message: res.msg,
          type: "error",
        });
      }
    },
    stopTimeKeeping() {
      sdkTime("浏览展商", this.details.companyName, this.timeKeeping);
      clearInterval(this.interval);
    },
    handleShowBusinessInquiry() {
      this.dialogVisible = true;
      sdkClick("商贸洽谈", this.details.companyName);
    },
  },
};
</script>
<style lang="scss" scoped>
.dialog_box {
  /deep/.el-dialog__body {
    padding: 10px 30px 30px 30px !important;
  }
  /deep/ .el-dialog {
    top: 5%;
    width: 480px !important;
    height: 496px !important;
    background: #ffffff;
    border-radius: 20px;
    position: relative;
  }
  .dialog_line {
    width: 100%;
    border-bottom: 1px solid #f3f3f3;
  }

  .dialog_box_top {
    position: relative;
    display: flex;
    padding: 10px;
    align-items: center;
    height: 110px;
    background: #f7f8fa;
    border-radius: 8px;
    margin: 20px 0 15px 0;
  }

  .dialog_title_picture {
    position: relative;
    margin-right: 10px;
  }

  .dialog_title_picture > img:first-child {
    width: 65px;
    height: 65px;
    border-radius: 50%;
  }

  .dialog_title_picture > img:nth-child(2) {
    width: 20px;
    height: 20px;
    position: absolute;
    bottom: 0;
    right: 0;
  }

  .dialog_title_name {
    //display: flex;
    margin-bottom: 5px;
    align-items: center;
    margin-left: 10px;
  }

  .dialog_title_name > div:nth-child(1) {
    margin-bottom: 3px;
    font-weight: 500;
    font-size: 20px;
    color: #001a33;
    line-height: 30px;
    letter-spacing: 1px;
    //text-align: center;
    font-style: normal;
  }

  .dialog_title_name > div:nth-child(2) {
    margin-bottom: 3px;
    font-weight: 400;
    font-size: 14px;
    color: #001a33;
    line-height: 21px;
    //text-align: center;
    font-style: normal;
  }

  .dialog_company {
    font-weight: 400;
    font-size: 14px;
    color: #001a33;
    line-height: 21px;
    //text-align: left;
    font-style: normal;
  }
  .title_title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #000000;
    line-height: 22px;
    margin: 10px 0;
  }
  /deep/ .el-dialog__footer {
    position: absolute;
    display: flex;
    margin: auto;
    left: 0;
    right: 0;
    justify-content: center;
    bottom: 0;
  }
  .dialog_submit {
    width: 180px;
    height: 42px;
    border-radius: 9px;
    background-color: #004190;
    border-color: #004190;
  }

  .dialog_submit:hover {
    background-color: #004190;
    opacity: 0.9;
  }
}
.content_wrap {
  padding: 80px 0;
  .content_title {
    margin-bottom: 30px;
  }
  .content-top {
    padding: 20px 30px;
    background: #f9fafc;
    border-radius: 30px;
    margin-bottom: 30px;
    font-size: 14px;
    color: #001a33;
    line-height: 20px;
    position: relative;
    .collect {
      min-width: 124px;
      padding: 0 10px;
      height: 40px;
      color: #fff;
      font-size: 14px;
      cursor: pointer;
      text-align: center;
      line-height: 40px;
      background: #77a5e6;
      border-radius: 8px;
      box-sizing: border-box;
      &:hover {
        background: #1d2379;
      }
      .icon {
        width: 15px;
        height: 15px;
        margin-left: 7px;
      }
    }
    .bus-btn {
      margin-top: 15px;
      opacity: 0.8;
      background: #90c31f !important;
      &:hover {
        opacity: 1;
      }
    }
    .active {
      background: #1d2379;
    }
    .img-wrap {
      width: 190px;
      height: 125px;
      margin-right: 20px;
      background: #fff;
    }
    .content-text {
      flex: 1;
      & > div {
        margin-bottom: 10px;
        &:last-child {
          margin-bottom: 0;
        }
      }
      .title {
        font-weight: 500;
        font-size: 20px;
        color: #001a33;
        line-height: 28px;
      }
      .content-label {
        span {
          height: 18px;
          padding: 0 10px;
          font-size: 12px;
          color: #447bce;
          line-height: 18px;
          background: #dfe7f1;
          border-radius: 4px;
        }
      }
    }
  }
  .demand-wrap {
    margin-bottom: 30px;
    & > div {
      padding: 30px;
      height: 300px;
      box-sizing: border-box;
      background: #f9fafc;
      border-radius: 30px;
    }
    .left {
      padding-top: 35px;
      width: 300px;
      margin-right: 30px;
      font-weight: 500;
      font-size: 18px;
      color: #001a33;
      line-height: 25px;
      text-align: center;
      .img {
        width: 210px;
        height: 210px;
        margin-bottom: 10px;
      }
    }
    .right {
      width: calc(100% - 330px);
      .title {
        font-weight: 500;
        font-size: 18px;
        color: #001a33;
        line-height: 25px;
        margin-bottom: 15px;
      }
      .banner-swiper {
        width: 100%;
        cursor: pointer;
        .swiper-item {
          width: 100%;
          height: 211px;
          padding: 20px;
          font-size: 15px;
          color: #001a33;
          line-height: 24px;
          background: #fff;
          border-radius: 12px;
          box-sizing: border-box;
          position: relative;
          .title {
            font-size: 16px;
            font-weight: 500;
            margin-bottom: 10px;
          }
          .swiper-btn {
            width: 104px;
            height: 36px;
            color: #fff;
            font-size: 14px;
            line-height: 36px;
            text-align: center;
            background: #1d2379;
            border-radius: 18px;
            cursor: pointer;
            position: absolute;
            right: 20px;
            bottom: 20px;
          }
        }
      }
    }
  }
  .content-bottom {
    padding: 30px;
    background: #f9fafc;
    border-radius: 30px;
    /deep/ p img {
      max-width: 100%;
      display: inline-block;
    }
    .title {
      font-weight: 500;
      font-size: 18px;
      color: #001a33;
      line-height: 25px;
      padding-bottom: 10px;
    }
    .content-profile {
      font-size: 15px;
      color: #001a33;
      line-height: 24px;
      margin-bottom: 30px;
    }
    .content-p {
      font-size: 15px;
      color: #001a33;
      line-height: 24px;
    }
  }
  .content-subtitle {
    padding: 50px 0 30px;
  }
}
.dialog-wrap {
  font-size: 14px;
  text-align: center;
  color: rgb(255, 60, 60);
  .qrcode {
    width: 200px;
    height: 200px;
    margin-bottom: 20px;
  }
}
@media only screen and (max-width: 1280px) {
}
@media only screen and (max-width: 767px) {
  .content_wrap {
    padding: 0.58rem 0;
    .content-top {
      font-size: 0.23rem;
      line-height: 0.33rem;
      padding: 0.29rem;
      flex-wrap: wrap;
      margin-bottom: 0.58rem;
      .img-wrap {
        width: 3.65rem;
        height: 2.4rem;
      }
      .content-text {
        width: 100%;
        padding: 0.29rem 0 0.38rem;
        .title {
          font-size: 0.31rem;
          line-height: 0.42rem;
        }
      }
      .btn-wrap {
        width: 100%;
        display: flex;
        .collect {
          min-width: 2.9rem;
        }
        .bus-btn {
          margin: 0 0 0 16px;
        }
      }
    }
    .demand-wrap {
      flex-wrap: wrap;
      .left {
        width: 100%;
        margin-right: 0;
        padding-top: 0.38rem;
      }
      .right {
        width: 100%;
        padding: 0.38rem 0.29rem;
        margin-top: 0.58rem;
        .banner-swiper {
          width: 6.15rem;
        }
      }
    }
    .content-bottom {
      padding: 0.38rem 0.29rem;
      .title {
        font-size: 0.31rem;
        line-height: 0.42rem;
      }
      .content-profile {
        font-size: 0.29rem;
        line-height: 0.46rem;
        margin-bottom: 0.58rem;
      }
      .content-p {
        font-size: 0.29rem;
        line-height: 0.46rem;
      }
    }
  }
  /deep/ .el-dialog {
    width: 80% !important;
  }
  .dialog-wrap .qrcode {
    width: 100%;
    height: 100%;
  }
}
</style>